<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.ID_NAME" | translate }}</div>
  <div>{{ organization.callerIdName }}</div>
</section>

<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.PHONE_NUMBER" | translate }}</div>
  <div>{{ organization.callerIdNumber }}</div>
</section>

<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
    {{ "ONSIP_I18N.EDIT" | translate }}
  </button>
</div>
